import {
    createBrowserRouter, RouteObject
} from "react-router-dom";
import {routes} from "./route/main";

const router = createBrowserRouter((routes as RouteObject[]));

export default router;